// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aN","headerWrapper":"aO","iconButtonFrame":"aP","iconButton":"aQ","icon":"aR","header":"aS","form":"aT","buttonWrapper":"aU","button":"aV"};